export const getQuestionPluralForm = (count: number) => {
  if (count === 1) {
    return 'one question';
  } else {
    return `${count} questions`;
  }
};
